import { React } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';

import MenuItem from '@material-ui/core/MenuItem';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { useOrganizations } from 'hooks';
import { FormControl, Select } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  errorText: {
    color: theme.palette.error.light,
  },
  fullWidth: {
    width: '100%',
  },
}));

const UserOrgEdit = ({ desiredOrg, setUserOrg, organizationError, organizationErrorMessage }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { organizations } = useOrganizations();
  const defaultOrg = t('select_user_organization');

  const getOrganizationItems = () => {
    const organizationItems = [
      <MenuItem key={t('filter_organizations')} onClick={() => setUserOrg()} value={defaultOrg}>
        {defaultOrg}
      </MenuItem>,
    ];
    _.forEach(organizations, (organization, organizationID) => {
      organizationItems.push(
        <MenuItem key={organizationID} onClick={() => setUserOrg(organization)} value={organization.name}>
          {organization.name}
        </MenuItem>
      );
    });
    return organizationItems;
  };

  return (
    <FormControl className={classes.fullWidth}>
      <Select variant="outlined" value={desiredOrg ? desiredOrg.name : defaultOrg}>
        {getOrganizationItems()}
      </Select>
      {organizationError && (
        <Typography className={classes.errorText} variant="h9">
          {organizationErrorMessage}
        </Typography>
      )}
    </FormControl>
  );
};
UserOrgEdit.propTypes = {
  setUserOrg: PropTypes.func.isRequired,
  desiredOrg: PropTypes.object,
  organizationError: PropTypes.bool,
  organizationErrorMessage: PropTypes.string,
};

UserOrgEdit.desiredOrg = {
  desiredOrg: undefined,
  organizationError: false,
  organizationErrorMessage: '',
};

export default UserOrgEdit;
